// Components
import { Loading } from "components"
import { InputSection } from "./InputSection"

// Contexts
import { DataContext } from "../contexts"

// Form
import { FormProvider, useForm } from "react-hook-form"

// Types
import type { BuildType } from "../types"

// Utils
import { type FormType, useDetailByBuild } from "../utils"
import { useEffect } from "react"

export function Detail({
  build_id,
  onTotalAmountChange,
}: {
  build_id: number
  onTotalAmountChange?: (amount: number) => void
}): JSX.Element {
  // Hooks
  const { data, isLoading } = useDetailByBuild(build_id)
  
  return (
    <section className="container my-3 flex flex-col gap-3">
      {isLoading || !data ? (
        <Loading
          loading={isLoading}
          errorText="No data available"
        />
      ) : (
        <FormSection data={data} onTotalAmountChange={onTotalAmountChange} />
      )}
    </section>
  )
}

function FormSection({
  data,
  onTotalAmountChange,
}: {
  data: BuildType
  onTotalAmountChange?: (amount: number) => void
}): JSX.Element {
  // Vars
  const product = data.product

  // Form
  const defaultValues: FormType = {
    employee_id: product.employee_id,
    location_id: product.location_id,
    qty_build_unit: product.qty_build_unit,
    trx_code: product.trx_code,
    transaction_date: product.transaction_date,
    component_at_cost:product.component_at_cost,
    coa_overhead_id:0,
    total_cac:0,
    total_amount:0,
    overhead:0,
  }
  const methods = useForm<FormType>({
    defaultValues,
    disabled: true
  })

  // Notify parent when total_amount changes
  const { watch } = methods
  const watchedAmount = watch("total_amount")

  useEffect(() => {
    if (onTotalAmountChange) {
      onTotalAmountChange(watchedAmount)
    }
  }, [watchedAmount, onTotalAmountChange])

  return (
    <FormProvider {...methods}>
      <DataContext.Provider value={data}>
        <InputSection />
      </DataContext.Provider>
    </FormProvider>
  )
}